import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  addArray as addDocumentTemplateSourceArray,
  setCursor,
} from '../redux/documentTemplateSources'

export default function * fetchDocumentTemplateSources () {
  yield put(setLoadStatus({
    isLoading: true,
    isLoaded: false
  }))

  const state = yield select()

  const cursor = state.kanbo.documentTemplateSources.cursor

  const args = {
    limit: 20
  }

  if (cursor) {
    args.cursor = cursor
  }

  try {
    const { Sources, Cursor } = yield call(apiGetData, 'DocumentTemplateSources', args)

    yield put([
      addDocumentTemplateSourceArray(Sources.map(Source => ({
        id: Source.Id,
        name: Source.Name,
        url: Source.Url
      }))),
      setLoadStatus({
        isLoading: false,
        isLoaded: !Cursor
      }),
      setCursor(Cursor)
    ])
  } catch (error) {
    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))

    throw error
  }
}
